import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-teamworks-promotion',
  templateUrl: './teamworks-promotion.component.html',
  styleUrls: ['./teamworks-promotion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamworksPromotionComponent {
  constructor() {
  }
}
